import { render, staticRenderFns } from "./Auto_update.vue?vue&type=template&id=dd7bcb60&scoped=true"
import script from "./Auto_update.vue?vue&type=script&lang=js"
export * from "./Auto_update.vue?vue&type=script&lang=js"
import style0 from "./Auto_update.vue?vue&type=style&index=0&id=dd7bcb60&prod&lang=css"
import style1 from "./Auto_update.vue?vue&type=style&index=1&id=dd7bcb60&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7bcb60",
  null
  
)

export default component.exports